import { BadgeContent } from "./content-elements/BadgeContent";
import { CircleContent } from "./content-elements/CircleContent";
import { ContainerContent } from "./content-elements/ContainerContent";
import { IconContent } from "./content-elements/IconContent";
import { TextContent } from "./content-elements/TextContent";

export class ContentFactory {
  static createText(text: string): TextContent {
    return new TextContent(text);
  }

  static createContainer(): ContainerContent {
    return new ContainerContent();
  }

  static createBadge(content?: string): BadgeContent {
    return new BadgeContent(content ?? "");
  }

  static createCircle(content?: string): CircleContent {
    return new CircleContent(content ?? "");
  }

  static createIcon(icon: JSX.Element): IconContent {
    return new IconContent(icon);
  }
}
